import { dateFormater, flipDate } from "./common";
import i18n from "utils/i18n";

const getStopsLabel = (nbStops) => {
    if (nbStops === 0) return i18n.t("direct");
    if (nbStops === 1) return i18n.t("stop1");
    return `${i18n.t("stops")} : ${nbStops}`;
};

export const parseFlight = (flight, airports, airlines) => {
    if (!flight || !airports) return null;
    const parsedFlight = {
        bounds: [],
        price: flight.recommendation.price.detailed_price.total,
    };

    const bound1 = flight.bounds[0];
    const tmp = {
        nbStops: getStopsLabel(bound1?.nbStops),
        departure_city: airports[bound1.departure.locationId]?.city_name,
        arrival_city: airports[bound1.arrival.locationId]?.city_name,
        departure_airport: `${bound1.departure.locationId},${
            airports[bound1.departure.locationId]?.name
        }`,
        arrival_airport: `${bound1.arrival.locationId},${
            airports[bound1.arrival.locationId]?.name
        }`,
        duration: convertTime(bound1.elapsedFlyingTime),
        duration2: convertTime2(bound1.elapsedFlyingTime),
        departure_time: bound1.departure.time,
        arrival_time: bound1.arrival.time,
        airline: bound1.airlines[0],
        airline_name: airlines[bound1.airlines[0]]?.name,
        date: bound1?.departure?.full_date,
    };
    parsedFlight.bounds.push(tmp);
    if (flight.bounds.length > 1) {
        for (let i = 1; i < flight.bounds.length; i++) {
            const bound = flight.bounds[i];
            const tmp2 = {
                nbStops: getStopsLabel(bound?.nbStops),
                departure_city: airports[bound.departure.locationId]?.city_name,
                arrival_city: airports[bound.arrival.locationId]?.city_name,
                departure_airport: `${bound.departure.locationId},${
                    airports[bound.departure.locationId]?.name
                }`,
                arrival_airport: `${bound.arrival.locationId},${
                    airports[bound.arrival.locationId]?.name
                }`,
                duration: convertTime(bound.elapsedFlyingTime),
                duration2: convertTime2(bound.elapsedFlyingTime),
                departure_time: bound.departure.time,
                arrival_time: bound.arrival.time,
                airline: bound.airlines[0],
                airline_name: airlines[bound.airlines[0]]?.name,
                date: bound?.departure?.full_date,
            };
            parsedFlight.bounds.push(tmp2);
        }
    }

    return parsedFlight;
};

export const createFareRulesPayload = (flight) => {
    try {
        const {
            nrOfAdult,
            nrOfChild,
            nrOfInfant,
            nrOfInfantWithSeat,
            nrOfYouth,
            nrOfSenior,
        } = getPassengers(flight);
        const selectedDepartures = [flight.bounds[0]];
        const selectedReturn =
            flight?.tripType === "rt" ? flight.bounds[1] : null;
        const payload = {
            bookingKey: flight?.recommendation?.bookingKey,
            bounds: flight.bounds.length,
            fareRuleType: "classicalRules",
            nrOfAdult: Number(nrOfAdult),
            nrOfChild: Number(nrOfChild),
            nrOfInfant: Number(nrOfInfant),
            nrOfInfantWithSeat: Number(nrOfInfantWithSeat),
            nrOfYouth: Number(nrOfYouth),
            nrOfSenior: Number(nrOfSenior),
            provider_id: Number(flight?.provider_id),
            fareAdvise:
                flight?.recommendation?.fareDetails[0][0]?.fares?.fareAdvise[0],
        };

        for (let i = 0; i < selectedDepartures.length; i++) {
            for (let j = 0; j < selectedDepartures[i].segments.length; j++) {
                payload[`bookingClass_${i + 1}s${j + 1}`] =
                    flight?.recommendation?.fareDetails[i][j]?.reservationClass;
                payload[`cabin_${i + 1}s${j + 1}`] =
                    flight?.recommendation?.fareDetails[i][j]?.cabin;
                const date =
                    selectedDepartures[i]?.segments[j]?.departure?.full_date;
                let time = selectedDepartures[i]?.segments[j]?.departure?.time;
                if (!time) {
                    time = "00:00";
                }
                payload[`departureDate_${i + 1}s${j + 1}`] = `${flipDate(
                    date
                )} ${time}:00`;
                payload[`flightNumber_${i + 1}s${j + 1}`] =
                    selectedDepartures[i]?.segments[j]?.flightOrtrainNumber;
                payload[`marketingCompany_${i + 1}s${j + 1}`] =
                    selectedDepartures[i]?.segments[j]?.marketingCarrier;
                payload[`from_${i + 1}s${j + 1}`] =
                    selectedDepartures[i]?.segments[j]?.departure?.locationId;
                payload[`to_${i + 1}s${j + 1}`] =
                    selectedDepartures[i]?.segments[j]?.arrival?.locationId;
            }

            payload[`destination_${i + 1}`] =
                selectedDepartures[i]?.segments[
                    selectedDepartures[i].segments.length - 1
                ]?.arrival?.locationId;
            payload[`origin_${i + 1}`] =
                selectedDepartures[i]?.segments[0]?.departure?.locationId;
            payload[`nrOfSegments_${i + 1}`] =
                selectedDepartures[i]?.segments.length;
        }

        if (selectedReturn) {
            for (let i = 0; i < selectedReturn.segments.length; i++) {
                payload[`bookingClass_2s${i + 1}`] =
                    flight?.recommendation?.fareDetails[1][i]?.reservationClass;
                payload[`cabin_2s${i + 1}`] =
                    flight?.recommendation?.fareDetails[1][i]?.cabin;
                const date = selectedReturn?.segments[i]?.departure?.full_date;
                let time = selectedReturn?.segments[i]?.departure?.time;
                if (!time) {
                    time = "00:00";
                }
                payload[`departureDate_2s${i + 1}`] = `${flipDate(
                    date
                )} ${time}:00`;
                payload[`flightNumber_2s${i + 1}`] =
                    selectedReturn?.segments[i]?.flightOrtrainNumber;
                payload[`marketingCompany_2s${i + 1}`] =
                    selectedReturn?.segments[i]?.marketingCarrier;
                payload[`from_2s${i + 1}`] =
                    selectedReturn?.segments[i]?.departure?.locationId;
                payload[`to_2s${i + 1}`] =
                    selectedReturn?.segments[i]?.arrival?.locationId;
            }

            payload[`destination_2`] =
                selectedReturn.segments[
                    selectedReturn.segments.length - 1
                ]?.arrival?.locationId;
            payload[`origin_2`] =
                selectedReturn.segments[0]?.departure?.locationId;
            payload[`nrOfSegments_2`] = selectedReturn.segments.length;
        }

        return payload;
    } catch (error) {
        console.error(error);
        return null;
    }
};

export const getPassengers = (flight) => {
    return {
        nrOfAdult: flight.recommendation.price.breakdown?.ADT?.number || 0,
        nrOfChild: flight.recommendation.price.breakdown?.CHD?.number || 0,
        nrOfInfant: flight.recommendation.price.breakdown?.INF?.number || 0,
        nrOfInfantWithSeat: 0,
        nrOfYouth: 0,
        nrOfSenior: flight.recommendation.price.breakdown?.SRC?.number || 0,
    };
};

export const getPassengersNumbers = (breakdown) => {
    if (!breakdown)
        return {
            nrOfAdult: 0,
            nrOfChild: 0,
            nrOfInfant: 0,
            nrOfInfantWithSeat: 0,
            nrOfYouth: 0,
            nrOfSenior: 0,
        };
    return {
        nrOfAdult: Number(breakdown?.ADT?.number) || 0,
        nrOfChild: Number(breakdown?.CHD?.number) || 0,
        nrOfInfant: Number(breakdown?.INF?.number) || 0,
        nrOfInfantWithSeat: Number(breakdown?.INFS?.number) || 0,
        nrOfYouth: Number(breakdown?.YTH?.number) || 0,
        nrOfSenior: Number(breakdown?.SRC?.number) || 0,
    };
};

export const getMinMaxPrice = (flights) => {
    if (!Array.isArray(flights) || flights.length === 0) return [0, 1];
    let min = Infinity;
    let max = -Infinity;
    for (let i = 0; i < flights.length; i++) {
        const flight = flights[i];
        const price = +flight?.recommendation?.price.detailed_price.total;
        if (price < min) {
            min = price;
        }
        if (price > max) {
            max = price;
        }
    }
    if (min === max) return [min, max + 1];
    return [min, max];
};

export const getTotalFlyingTimeInSec = (flight) => {
    if (!flight) return 0;
    let total = 0;
    flight.bounds.forEach((bound) => {
        total += convertTimeToSec(bound.elapsedFlyingTime);
    });
    return total;
};

const convertTimeToSec = (time) => {
    const [hours, minutes] = time.split(":");
    return hours * 3600 + minutes * 60;
};

export const convertTime = (time) => {
    const [hoursRaw, minutesRaw] = time.split(":");
    const hours = String(Number(hoursRaw));
    const minutes = String(Number(minutesRaw));

    return `\u200F${hours} ${i18n.t("hours")} ${i18n.t("and")} ${minutes} ${i18n.t("mins")} \u200F`;

};

export const convertTime2 = (time) => {
    const [hours, minutes] = time.split(":");
    return `${hours}h ${minutes}m`;
};


const setPassengerRequestTaxFareParams = (
    passengerNumbers,
    payload,
    type,
    data
) => {
    if (passengerNumbers > 0) {
        payload[type + "_tax"] =
            data["recommendation"]["price"]["breakdown"][type]["totalTax"];
        payload[type + "_totalFare"] =
            data["recommendation"]["price"]["breakdown"][type]["totalFare"];
    }
    return payload;
};

export const createAirValidatePayload = (flight) => {
    const {
        nrOfAdult,
        nrOfChild,
        nrOfInfant,
        nrOfInfantWithSeat,
        nrOfYouth,
        nrOfSenior,
    } = getPassengers(flight);
    try {
        const payload = {
            nrOfItinerary: flight?.recommendation?.flights?.length || 1,
            bookingKey: flight?.recommendation?.bookingKey,
            customer_phone_countrycode: "213",
            fareAdvise:
                flight?.recommendation?.fareDetails[0][0]?.fares?.fareAdvise[0], // zoneB todo
            validatingCarrier: flight.recommendation.validatingCarrier,
            nrOfAdult: Number(nrOfAdult),
            nrOfChild: Number(nrOfChild),
            nrOfInfant: Number(nrOfInfant),
            nrOfInfantWithSeat: Number(nrOfInfantWithSeat),
            nrOfYouth: Number(nrOfYouth),
            nrOfSenior: Number(nrOfSenior),
            provider_id: Number(flight?.provider_id),
            openReturn: false,
            tripType: flight?.tripType,
        };

        for (let i = 0; i < flight.bounds.length; i++) {
            payload[`destination_${i + 1}`] =
                flight.bounds[i].segments[
                    flight.bounds[i].segments.length - 1
                ].arrival.locationId;
            payload[`nrOfSegments_${i + 1}`] = flight.bounds[i].segments.length;
            payload[`origin_${i + 1}`] =
                flight.bounds[i].segments[0].departure.locationId;

            for (let j = 0; j < flight.bounds[i].segments.length; j++) {
                payload[`bookingClass_${i + 1}s${j + 1}`] =
                    flight?.recommendation?.fareDetails[i][j]?.reservationClass;
                payload[`cabin_${i + 1}s${j + 1}`] =
                    flight?.recommendation?.fareDetails[i][j]?.cabin;

                const date = flight.bounds[i].segments[j].departure.full_date;
                let time = flight.bounds[i].segments[j].departure.time;
                if (!time) {
                    time = "00:00";
                    flight.bounds[i].segments[j].flightOrtrainNumber = "OPEN";
                    flight.bounds[i].segments[j].marketingCarrier = "AH";
                    payload.openReturn = true;
                }
                payload[`departureDate_${i + 1}s${j + 1}`] = `${flipDate(
                    date
                )} ${time}:00`;
                payload[`flightNumber_${i + 1}s${j + 1}`] =
                    flight.bounds[i]?.segments[j]?.flightOrtrainNumber;
                payload[`marketingCompany_${i + 1}s${j + 1}`] =
                    flight.bounds[i]?.segments[j]?.marketingCarrier;
                payload[`from_${i + 1}s${j + 1}`] =
                    flight.bounds[i].segments[j].departure.locationId;
                payload[`to_${i + 1}s${j + 1}`] =
                    flight.bounds[i].segments[j].arrival.locationId;
            }
        }

        setPassengerRequestTaxFareParams(
            Number(nrOfAdult),
            payload,
            "ADT",
            flight
        );
        setPassengerRequestTaxFareParams(
            Number(nrOfChild),
            payload,
            "CHD",
            flight
        );
        setPassengerRequestTaxFareParams(
            Number(nrOfInfant),
            payload,
            "INF",
            flight
        );
        setPassengerRequestTaxFareParams(
            Number(nrOfInfantWithSeat),
            payload,
            "INFS",
            flight
        );
        setPassengerRequestTaxFareParams(
            Number(nrOfYouth),
            payload,
            "YTH",
            flight
        );
        setPassengerRequestTaxFareParams(
            Number(nrOfSenior),
            payload,
            "SRC",
            flight
        );

        return payload;
    } catch (error) {
        console.error(error);
        return null;
    }
};

const MAP_TYPES = {
    Adult: "ADT",
    Child: "CHD",
    Infant: "INF",
    InfantWithSeat: "INFS",
    Youth: "YTH",
    Senior: "SRC",
};
const setPassengersParams = (
    payload,
    travllerDetails,
    isDomesticFlight,
    type,
    nbr,
    index
) => {
    if (nbr > 0) {
        for (let i = 0; i < nbr; i++) {
            if (
                (travllerDetails[`passportNumber${type}${i + 1}`] &&
                    travllerDetails[`passportExpiry${type}${i + 1}`]) ||
                !isDomesticFlight
            ) {
                payload["addTravellerPassportNumber_" + index] = true;
                payload["travellerPassportExp_" + index] = dateFormater(
                    travllerDetails[`passportExpiry${type}${i + 1}`]
                );
                payload["travellerPassportNumber_" + index] =
                    travllerDetails[`passportNumber${type}${i + 1}`];
            } else {
                payload["addTravellerPassportNumber_" + index] = false;
                payload["travellerPassportExp_" + index] = null;
                payload["travellerPassportNumber_" + index] = null;
            }

            if (
                travllerDetails[`cardNumber${type}${i + 1}`] &&
                travllerDetails[`cardExpiry${type}${i + 1}`]
            ) {
                payload["travellerIDCardExp_" + index] = dateFormater(
                    travllerDetails[`cardExpiry${type}${i + 1}`]
                );
                payload["travellerIDCardNumber_" + index] =
                    travllerDetails[`cardNumber${type}${i + 1}`];
            } else {
                payload["travellerIDCardExp_" + index] = null;
                payload["travellerIDCardNumber_" + index] = null;
            }
            payload[`travellerFirstName_` + index] =
                travllerDetails[`firstName${type}${i + 1}`];
            payload[`travellerLastName_` + index] =
                travllerDetails[`lastName${type}${i + 1}`];
            payload[`travellerMiddleName_` + index] = null;
            payload[`travellerNAt_` + index] = "DZA-DZ";
            payload[`travellerSex_` + index] =
                travllerDetails[`title${type}${i + 1}`]?.value === "Mr"
                    ? "M"
                    : "F";
            payload[`travellerType_` + index] = MAP_TYPES[type];
            payload[`travellerBirth_` + index] = dateFormater(
                travllerDetails[`dob${type}${i + 1}`]
            );
            
            switch(type) {
                case "Adult":
                    if (travllerDetails[`exchangeDocumentsAdult${i + 1}`]) {
                        if (payload["ADT_documents"]) {
                            payload["ADT_documents"].push(travllerDetails[`exchangeDocumentsAdult${i + 1}`]);
                        } else {
                            payload["ADT_documents"] = [travllerDetails[`exchangeDocumentsAdult${i + 1}`]];
                        }
                    }
                    break;
                case "Child":
                    if (travllerDetails[`exchangeDocumentsChild${i + 1}`]) {
                        if (payload["CHD_documents"]) {
                            payload["CHD_documents"].push(travllerDetails[`exchangeDocumentsChild${i + 1}`]);
                        } else {
                            payload["CHD_documents"] = [travllerDetails[`exchangeDocumentsChild${i + 1}`]];
                        }
                    }
                    break;
                case "Infant":
                    if (travllerDetails[`exchangeDocumentsInfant${i + 1}`]) {
                        if (payload["INF_documents"]) {
                            payload["INF_documents"].push(travllerDetails[`exchangeDocumentsInfant${i + 1}`]);
                        } else {
                            payload["INF_documents"] = [travllerDetails[`exchangeDocumentsInfant${i + 1}`]];
                        }
                    }
                    break;
                case "InfantWithSeat":
                    if (travllerDetails[`exchangeDocumentsInfantWithSeat${i + 1}`]) {
                        if (payload["INS_documents"]) {
                            payload["INS_documents"].push(travllerDetails[`exchangeDocumentsInfantWithSeat${i + 1}`]);
                        } else {
                            payload["INS_documents"] = [travllerDetails[`exchangeDocumentsInfantWithSeat${i + 1}`]];
                        }
                    }
                    break;
                case "Youth":
                    if (travllerDetails[`exchangeDocumentsYouth${i + 1}`]) {
                        if (payload["YTH_documents"]) {
                            payload["YTH_documents"].push(travllerDetails[`exchangeDocumentsYouth${i + 1}`]);
                        } else {
                            payload["YTH_documents"] = [travllerDetails[`exchangeDocumentsYouth${i + 1}`]];
                        }
                    }
                    break;
                case "Senior":
                    if (travllerDetails[`exchangeDocumentsSenior${i + 1}`]) {
                        if (payload["SRC_documents"]) {
                            payload["SRC_documents"].push(travllerDetails[`exchangeDocumentsSenior${i + 1}`]);
                        } else {
                            payload["SRC_documents"] = [travllerDetails[`exchangeDocumentsSenior${i + 1}`]];
                        }
                    }
                    break;
                default:
                    break;
            }
            
            if (type === "Adult") payload["travellerWithInfant_" + (i + 1)] = 0;

            type === "Infant"
                ? (payload["travellerWithInfant_" + (i + 1)] = index)
                : (payload["specialServiceRequested_" + index] = null);
            index++;
        }
    }

    return index;
};

export const createConfirmationPayload = (flight, travllersDetails) => {
    const {
        nrOfAdult,
        nrOfChild,
        nrOfInfant,
        nrOfInfantWithSeat,
        nrOfYouth,
        nrOfSenior,
    } = getPassengers(flight);
    const payload = createAirValidatePayload(flight);
    let index = 1;
    index = setPassengersParams(
        payload,
        travllersDetails,
        flight?.isDomesticFlight,
        "Adult",
        nrOfAdult,
        index
    );
    index = setPassengersParams(
        payload,
        travllersDetails,
        flight?.isDomesticFlight,
        "Child",
        nrOfChild,
        index
    );
    index = setPassengersParams(
        payload,
        travllersDetails,
        flight?.isDomesticFlight,
        "Infant",
        nrOfInfant,
        index
    );
    index = setPassengersParams(
        payload,
        travllersDetails,
        flight?.isDomesticFlight,
        "InfantWithSeat",
        nrOfInfantWithSeat,
        index
    );
    index = setPassengersParams(
        payload,
        travllersDetails,
        flight?.isDomesticFlight,
        "Youth",
        nrOfYouth,
        index
    );
    setPassengersParams(
        payload,
        travllersDetails,
        flight?.isDomesticFlight,
        "Senior",
        nrOfSenior,
        index
    );
    payload["total_price"] = flight.recommendation.price.detailed_price.total;
    payload["customer_city"] = "Alger-Alger";
    payload["customer_country"] =
        travllersDetails["customerCountry"]?.value || "Algeria";
    payload["customer_email"] = travllersDetails["customerEmail"];
    payload["customer_phoneNumber"] = travllersDetails["customerMobileNo"];
    payload["customer_phone_countrycode"] =
        travllersDetails["customerCountryCode"]?.id + "";
    payload["customer_address"] = travllersDetails["customerAddress"] || "";
    payload["point_of_sale_id"] = null;
    payload["card_type"] = null;
    payload["card_number"] = null;
    payload["card_exp_month"] = null;
    payload["card_exp_year"] = null;
    payload["onholdbooking"] = false;
    payload["extraservices"] = [];
    return payload;
};
